/* ============================================================
   Guday A/B Test — motor client-side genérico (reutilizável)
   ------------------------------------------------------------
   Substitui o Shopify Rollout. Sorteia o visitante (control/variant),
   persiste em cookie 1ª-parte (domínio raiz) + localStorage backup.

   PRINCÍPIO CENTRAL — GATILHO DE CONTAGEM:
   Sorteia no load, mas SÓ CONTA a sessão no teste quando o usuário passa
   pelo GATILHO (activationSelector — ex: clicar num bundle). Aí dispara o
   evento GA4 + grava cart attributes (_ab_test/_ab_variant) que viajam pro
   order (lidos pelo guday-dash). Quem não ativa é ignorado.
   ⚠️ O gatilho DEVE ser pré-tratamento (antes da variante divergir): assim o
   split no gatilho é ~50/50 e o SRM vale medido nele. Neste teste, a LP é
   idêntica nos 2 grupos até o clique (o pop-up só aparece depois). ✅

   FLEXÍVEL: todo o comportamento vem do bloco AB = {...} abaixo.
   Teste novo = trocar o config + apontar pro asset da variante + definir o gatilho.

   Fluxo:
     load → (preview? força variante + modal, NÃO conta) →
            sorteia/lê bucket → se variant injeta variantAsset
     GATILHO (clica em activationSelector) → 1ª vez: GA4 + cart attribute
   Doc: PLANO-sistema-ab-test.md
   ============================================================ */
(function () {
  'use strict';

  /* ====== CONFIG (editável — define o teste) — SLOT 3 (AB#03) ====== */
  var AB = {
    slot: 3,                                    // SLOT dedicado → deriva _ab3_*, ab3_preview, gd_ab3_ (ver abtests-documentation.md §🎰)
    testName: 'popup-multiproduto-v1',          // _ab3_test + ab_test_name (GA4) + test_name (Supabase)
    pages: ['/pages/lp-5-razoes-bundles', '/pages/lp-garrafa', '/pages/lp-mini-pote'], // onde o teste roda (path prefix) — 3 LPs, dados SOMADOS (mesmo bucket/test)
    split: 0.5,                                 // fração do grupo "variant" (0..1)
    variants: ['control', 'variant'],          // nomes dos 2 grupos
    activationSelector: '[data-offer-add]',     // GATILHO padrão (5-Razões). ⚠️ Sobrescrito por perPage no init() conforme a LP.
    variantAsset: 'ups-multi.js',               // asset injetado no grupo "variant" (pop-up MULTI-PRODUTO — 3 cards)
    assetVersion: '20260711e',                  // BUMPAR a cada mudança em ups-multi.js (cache-bust). 20260711e: +3ª LP lp-mini-pote (seletor [data-og4-add], nativeFlow ajax-add; pop-up Creatina Açaí+Mel+HSN igual garrafa). 20260710b: teste roda em 2 LPs (5-razoes-bundles + garrafa); +Creatina Açaí (vid 53117628514613); bundle 1/2 potes → Creatina Açaí no lugar do Gaba; garrafa → Creatina Açaí+Mel+HSN fixo; perPage (selector/nativeFlow/lpSource por LP). 20260710a: Gaba/HSN → produtos "20% OFF" (compare_at_price real: gaba-20-off vid 53117622780213, hsn-...-20-off vid 53117625172277). 20260708d: título sem ponto final. 20260708c: copy nova (Opção 2). 20260708b: card 3 Vinagre→HSN. 20260708a: fix injeção antes do kill switch
    cookieDays: 90,
    ga4Event: 'ab_exposure',                    // evento GA4 disparado no gatilho
    // Supabase (3ª fonte — registro cru). Inserção no GATILHO (pessoa parada no pop-up).
    // anon key é pública por design (RLS limita a INSERT-only). Se falhar: silencioso.
    supabaseUrl: 'https://avralwctwnopbkeuenal.supabase.co',   // Project URL
    supabaseAnonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImF2cmFsd2N0d25vcGJrZXVlbmFsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODI2MDIxOTMsImV4cCI6MjA5ODE3ODE5M30.ceXZp_LgruRndOHb6S6qJVheWqTaGVZzwN0Qugu4lw4',  // anon/public key (pública por design — RLS limita a INSERT-only)
    supabaseTable: 'ab_events',
    // KILL SWITCH: estado on/off lido da tabela ab_config (anon SELECT). Liga/desliga o teste
    // sem deploy (via guday-ab-dash --enable/--disable). Fail-safe: se a leitura falhar → OFF.
    // O preview (?ab3_preview=) IGNORA isso e sempre funciona.
    supabaseConfigTable: 'ab_config',

    // ====== CONFIG POR PÁGINA (o teste roda em 2 LPs com arquiteturas diferentes) ======
    // Resolvido 1x no init() a partir do handle → fixa activationSelector + nativeFlow + lpSource
    // corretos SEM refatorar wireActivation/installClickHold. Preferido sobre um seletor combinado
    // '[data-offer-add],[data-og2-add]' porque este esconderia o bug do fallback do hold (que
    // gravava _lp_source hardcoded de 5-Razões na garrafa). nativeFlow diz como o fallback do
    // click-hold deve finalizar quando o pop-up não arma a tempo:
    //   'permalink' → navega direto p/ /cart/add?...&return_to=/checkout (5-Razões: o botão nativo já é permalink)
    //   'ajax-add'  → replica o fluxo nativo da garrafa: /cart/add.js + delay + /checkout (offer2.liquid:641-652)
    perPage: {
      'lp-5-razoes-bundles': { activationSelector: '[data-offer-add]', nativeFlow: 'permalink', lpSource: 'lp-5-razoes-bundles' },
      'lp-garrafa':          { activationSelector: '[data-og2-add]',    nativeFlow: 'ajax-add',  lpSource: 'lp-garrafa' },
      'lp-mini-pote':        { activationSelector: '[data-og4-add]',    nativeFlow: 'ajax-add',  lpSource: 'lp-mini-pote' }
    },
    nativeAddDelayMs: 600   // garrafa/mini-pote: delay pós-add.js antes do /checkout (espelha offer2/offer4 — conservador)
  };

  // config da página atual (resolvida no init a partir do último segmento do path).
  // Fallback: 5-Razões (comportamento histórico) se o handle não casar nenhuma entrada.
  var PAGE = null;
  function currentHandle() {
    var segs = (location.pathname || '').split('/').filter(Boolean);
    return (segs[segs.length - 1] || '').toLowerCase();
  }
  function resolvePageCfg() {
    var h = currentHandle();
    return AB.perPage[h] || AB.perPage['lp-5-razoes-bundles'];
  }

  if (window.__gudayAb3Init) return;           // idempotência (guard PRÓPRIO do slot 3, ≠ __gudayAbInit)
  window.__gudayAb3Init = true;

  /* ====== helpers ====== */
  function safe(fn) { return function () { try { return fn.apply(this, arguments); } catch (e) { /* silencioso */ } }; }
  var COOKIE_KEY = 'gd_ab3_' + AB.testName;     // cookie do SLOT 3 (≠ gd_ab_ do slot 1)
  var LS_KEY = COOKIE_KEY;

  function onTestPage() {
    var p = location.pathname;
    return AB.pages.some(function (pg) { return p.indexOf(pg) === 0; });
  }
  // Descobre o domínio mais ALTO onde o cookie "cola" testando na prática.
  // Robusto p/ TLDs compostos (.com.br, .co.uk) — onde slice(-2) falharia (".com.br"
  // é domínio público e o browser rejeita). Resultado cacheado.
  var _cookieDomain;
  function cookieDomain() {
    if (_cookieDomain !== undefined) return _cookieDomain;
    var host = location.hostname;
    if (/^(localhost|127\.0\.0\.1|\[?::1\]?)$/.test(host) || /^\d+\.\d+\.\d+\.\d+$/.test(host)) {
      return (_cookieDomain = ''); // sem domain= (host-only) p/ localhost/IP
    }
    var parts = host.split('.');
    var test = '__gd_dt_' + Date.now();
    // tenta do mais alto (ex: com.br) pro mais específico até colar
    for (var i = parts.length - 2; i >= 0; i--) {
      var cand = parts.slice(i).join('.');
      document.cookie = test + '=1; domain=.' + cand + '; path=/; SameSite=Lax';
      if (document.cookie.indexOf(test + '=1') !== -1) {
        document.cookie = test + '=; domain=.' + cand + '; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
        return (_cookieDomain = '.' + cand); // colou no domínio mais alto possível
      }
    }
    return (_cookieDomain = ''); // fallback host-only
  }
  function setCookie(name, val, days) {
    var d = new Date(); d.setTime(d.getTime() + days * 864e5);
    var dom = cookieDomain();
    document.cookie = name + '=' + encodeURIComponent(val) +
      '; expires=' + d.toUTCString() + '; path=/' + (dom ? '; domain=' + dom : '') + '; SameSite=Lax';
  }
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
  }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  function uuid() {
    if (window.crypto && crypto.randomUUID) { try { return crypto.randomUUID(); } catch (e) {} }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8); return v.toString(16);
    });
  }
  function getSessionId() {
    // id estável por visitante (mesmo cookie/LS do teste) — permite dedupe e funil no Supabase
    var k = 'gd_ab_sid';
    var id = getCookie(k) || lsGet(k);
    if (!id) { id = uuid(); setCookie(k, id, AB.cookieDays); lsSet(k, id); }
    return id;
  }

  function getPreviewVariant() {
    // ?ab3_preview=variant | control  (força a variante, NÃO conta nos dados) — param PRÓPRIO do slot 3
    var m = location.search.match(/[?&]ab3_preview=([^&]+)/);
    if (!m) return null;
    var v = decodeURIComponent(m[1]);
    return AB.variants.indexOf(v) >= 0 ? v : null;
  }

  /* ====== KILL SWITCH: lê o estado on/off da tabela ab_config (anon SELECT) ======
     Chama cb(true) só se o teste está enabled. Fail-safe: qualquer falha → cb(false)
     (na dúvida, NÃO roda o teste em produção). Só apikey (sem Authorization: Bearer). */
  function fetchEnabled(cb) {
    if (!AB.supabaseUrl || !AB.supabaseAnonKey) { cb(false); return; } // não configurado: OFF
    var url = AB.supabaseUrl.replace(/\/$/, '') + '/rest/v1/' + AB.supabaseConfigTable +
      '?select=enabled&test_name=eq.' + encodeURIComponent(AB.testName) + '&limit=1';
    fetch(url, { headers: { 'apikey': AB.supabaseAnonKey } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (rows) { cb(!!(rows && rows[0] && rows[0].enabled === true)); })
      .catch(function () { cb(false); }); // rede/RLS falhou → OFF
  }

  /* ====== bucket (sorteio estável) ====== */
  function resolveBucket() {
    getSessionId(); // garante o session_id já no load (estável p/ Supabase/dedupe)
    // 1. cookie  2. localStorage backup  3. sorteia
    var b = getCookie(COOKIE_KEY) || lsGet(LS_KEY);
    if (b && AB.variants.indexOf(b) >= 0) {
      // re-sela em ambos (reidrata o que faltar)
      setCookie(COOKIE_KEY, b, AB.cookieDays); lsSet(LS_KEY, b);
      return b;
    }
    b = (Math.random() < AB.split) ? AB.variants[1] : AB.variants[0]; // [control, variant]
    setCookie(COOKIE_KEY, b, AB.cookieDays); lsSet(LS_KEY, b);
    return b;
  }

  /* ====== injeta o asset da variante (o pop-up) ====== */
  function injectVariantAsset(assetOverride) {
    var asset = assetOverride || AB.variantAsset;   // preview pode forçar outro layout (ups-c.js)
    if (!asset) return;
    if (document.getElementById('gd-ab-variant-asset')) return;
    var s = document.createElement('script');
    s.id = 'gd-ab-variant-asset';
    s.src = assetUrl(asset);
    s.defer = true;
    document.head.appendChild(s);
  }
  function assetUrl(file) {
    // monta a URL do asset na pasta /assets da CDN, PRESERVANDO o ?v= (cache-bust).
    // Sem o ?v=, o browser pega a versão antiga em cache → mudanças não aparecem.
    // Referência preferida: o próprio <script> deste motor (ab-test-3.js) — seu ?v= RE-HASHEIA
    // a cada push do tema, então a URL do ups-multi muda junto e fura o cache do edge/browser.
    // ⚠️ Bug 07/Jul: o seletor antigo pedia "ab-test.js" (sem o -3) → NUNCA casava → caía no
    // fallback "primeiro script do CDN", cujo ?v= é de um asset CONGELADO (...1776367424, tipo
    // swiper/theme) → a URL do ups-multi ficava presa e o edge servia a versão VELHA mesmo após
    // push. Agora referencia ab-test*.js (qualquer slot). Ver [[cdn-shopify-minifica-js]].
    var ref = document.querySelector('script[src*="/assets/ab-test-3.js"]')
           || document.querySelector('script[src*="/assets/ab-test"]')
           || document.querySelector('script[src*="/cdn/shop/"][src*="/assets/"]')
           || document.querySelector('script[src*="/cdn/shop/"]');
    // av = versão MANUAL do asset injetado (ups-b/ups-c). BUMPAR a cada mudança nesses
    // arquivos pra furar o cache da CDN — o ?v= do ab-test.js só muda quando o ab-test muda,
    // então sozinho não invalida o cache do ups-b/ups-c quando só ELES mudam.
    var av = 'av=' + (AB.assetVersion || '1');
    if (ref && ref.src) {
      var u = ref.src;
      var qIdx = u.indexOf('?');
      var query = qIdx >= 0 ? (u.slice(qIdx) + '&' + av) : ('?' + av);  // ex: ?v=12345&av=3
      var base = (qIdx >= 0 ? u.slice(0, qIdx) : u).replace(/\/[^\/]*$/, '/'); // pasta /assets
      return base + file + query;                            // ...assets/ups-b.js?v=12345&av=3
    }
    return '/' + file + '?' + av; // fallback (preview local)
  }

  /* ====== saídas de tracking (3 fontes) ====== */
  function ga4(event, bucket) {
    try {
      // publica o bucket num registry compartilhado p/ o HELPER de permalink (gd-ab-checkout.js)
      // e outros motores lerem. Formato {variant, test} — o helper re-passa _ab3_test/_ab3_variant
      // no permalink de TODOS os slots ativos (§🎰). Slot 3 → chave 'ab3'.
      window.__gudayAbBuckets = window.__gudayAbBuckets || {};
      window.__gudayAbBuckets.ab3 = { variant: bucket, test: AB.testName };
      var params = { ab_test_name: AB.testName, ab_test_variant: bucket, ab3_variant: bucket };
      if (typeof window.gtag === 'function') window.gtag('event', event, params);
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: event }, params));
    } catch (e) {}
  }
  function cartAttr(bucket) {
    safe(function () {
      // _ab3_test/_ab3_variant: atributos DEDICADOS do SLOT 3. /cart/update.js faz MERGE →
      // coexistem com _ab1_*/_ab2_* de outros testes na mesma LP (não escreve os genéricos
      // _ab_* — esses são do slot 1). ⚠️ O pop-up finaliza via cart PERMALINK, que reconstrói
      // o cart e apaga estes attrs → o ups-multi.js re-passa via gd-ab-checkout.js (§🎰).
      fetch('/cart/update.js', {
        method: 'POST',
        keepalive: true,  // completa mesmo se a página navegar (control vai direto pro checkout)
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: {
          _ab3_test: AB.testName, _ab3_variant: bucket
        } })
      });
    })();
  }
  function logSupabase(event, bucket) {
    if (!AB.supabaseUrl || !AB.supabaseAnonKey) return; // não configurado: pula
    safe(function () {
      fetch(AB.supabaseUrl.replace(/\/$/, '') + '/rest/v1/' + AB.supabaseTable, {
        method: 'POST',
        keepalive: true,  // CRÍTICO p/ SRM: o control navega pro checkout no clique e abortaria
                          // o fetch em voo → exposure do control se perdia (SRM falso 22/78). keepalive
                          // completa a requisição mesmo durante a navegação (igual sendBeacon).
        headers: {
          // SÓ apikey — NÃO mandar Authorization: Bearer. Neste projeto, mandar a anon
          // key como Bearer faz o PostgREST tratá-la como JWT de sessão e cair num role
          // sem a policy → 401 (42501). Só com apikey ele resolve o role 'anon'. (testado 28/Jun)
          'Content-Type': 'application/json',
          'apikey': AB.supabaseAnonKey,
          'Prefer': 'return=minimal'
        },
        body: JSON.stringify({
          test_name: AB.testName,
          variant: bucket,
          event: event,                 // exposure | accept | decline | checkout
          session_id: getSessionId(),
          page: location.pathname,
          user_agent: navigator.userAgent
        })
        // se falhar (rede/RLS): silencioso — GA4 + cart attribute cobrem
      }).catch(function () {});
    })();
  }

  /* ====== GATILHO: só conta quando o usuário passa por activationSelector ====== */
  var activated = false, currentBucket = null;
  function activate(bucket) {
    if (activated) return; activated = true;
    ga4(AB.ga4Event, bucket);   // GA4 (comportamento)
    cartAttr(bucket);           // Shopify cart attribute (receita via order)
    logSupabase('exposure', bucket); // Supabase (registro cru)
    // ⚠️ SIMETRIA DE CHECKOUT (corrigido 10/Jul/2026): NÃO registramos 'checkout' aqui.
    // Nas 2 LPs o control TAMBÉM abre um pop-up (ups-c / ups-garrafa) antes de ir pro checkout —
    // então contar 'checkout' no clique do bundle inflaria o checkout-rate do control vs a variante
    // (que só conta no clique FINALIZAR/NÃO do pop-up). Agora AMBOS os grupos contam 'checkout' no
    // finish() do respectivo pop-up (via gudayAbTrack('checkout')): control e variante medem o
    // mesmo momento — "% que ativou e efetivamente foi pro checkout pelo pop-up".
  }

  function wireActivation(bucket) {
    currentBucket = bucket;
    // delegação no seletor do gatilho (pega cards que montam depois)
    document.addEventListener('click', function (e) {
      var t = e.target && e.target.closest ? e.target.closest(AB.activationSelector) : null;
      if (t) activate(bucket);
    }, true); // capture: roda mesmo que o ups-b.js dê preventDefault
  }

  /* ====== API pública p/ o asset da variante (ups-b.js) registrar proxies ======
     ex: window.gudayAbTrack('accept'|'decline'|'checkout') */
  window.gudayAbTrack = function (event) {
    if (!currentBucket) return;          // só no fluxo real (não no preview)
    ga4('ab_' + event, currentBucket);
    logSupabase(event, currentBucket);
  };

  /* ====== modal de PREVIEW (não conta nos dados) ====== */
  function showPreviewBanner(variant, asset) {
    if (document.getElementById('gd-ab-preview-banner')) return;
    var vLabel = variant; // control | variant (slot 3 tem 1 layout só)
    var bar = document.createElement('div');
    bar.id = 'gd-ab-preview-banner';
    bar.setAttribute('style', [
      'position:fixed', 'left:0', 'right:0', 'bottom:0', 'z-index:2147483647',
      'background:#16a34a', 'color:#fff', 'font:600 13px/1.3 -apple-system,Segoe UI,Roboto,Arial,sans-serif',
      'padding:10px 14px', 'text-align:center', 'box-shadow:0 -4px 16px rgba(0,0,0,.18)',
      'display:flex', 'align-items:center', 'justify-content:center', 'gap:8px'
    ].join(';'));
    // texto: completo no desktop, curto no mobile (alternados por media query). Sempre 1 linha.
    bar.innerHTML =
      '<span style="display:inline-flex;flex:0 0 auto;width:9px;height:9px;border-radius:50%;background:#bbf7d0;box-shadow:0 0 0 0 rgba(187,247,208,.7);animation:gdABpulse 1.6s infinite"></span>' +
      '<span class="gd-ab-pv-full" style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0">MODO PREVIEW - Teste: AB#03 - pop-up multi-produto - ' + vLabel + ' (Não conta nos dados)</span>' +
      '<span class="gd-ab-pv-short" style="white-space:nowrap;display:none">PREVIEW - AB#03 - ' + vLabel + '</span>';
    var st = document.createElement('style');
    st.textContent = '@keyframes gdABpulse{0%{box-shadow:0 0 0 0 rgba(187,247,208,.7)}70%{box-shadow:0 0 0 8px rgba(187,247,208,0)}100%{box-shadow:0 0 0 0 rgba(187,247,208,0)}}'
      + '@media(max-width:600px){#gd-ab-preview-banner .gd-ab-pv-full{display:none!important}#gd-ab-preview-banner .gd-ab-pv-short{display:inline!important}}';
    document.head.appendChild(st);
    document.body.appendChild(bar);
  }

  /* ====== init ====== */
  var init = safe(function () {
    if (!onTestPage()) return;

    // Resolve a config da LP atual (selector do gatilho + nativeFlow do fallback + lpSource).
    // Sobrescreve o activationSelector default (5-Razões) pelo da LP corrente ANTES de qualquer
    // uso (wireActivation, click-hold) — assim o gatilho conta no botão certo em cada LP.
    PAGE = resolvePageCfg();
    AB.activationSelector = PAGE.activationSelector;

    // STAND-DOWN: se a URL tem o preview de OUTRO teste (ex: ?ab_preview= do AB#01 ou ?ab2_preview=
    // do AB#02) e NÃO tem o preview DESTE (?ab3_preview=), este motor fica quieto — não bucketiza,
    // não injeta nada. Assim o preview de um teste fica isolado, sem o slot 3 real interferir.
    if (/[?&](ab_preview|ab2_preview)=/.test(location.search) && !/[?&]ab3_preview=/.test(location.search)) return;

    // PREVIEW: força a variante, mostra o banner, e NÃO conta (sai do tracking).
    // IGNORA o kill switch — preview sempre funciona, mesmo com o teste desligado.
    var preview = getPreviewVariant();
    if (preview) {
      if (preview === AB.variants[1]) injectVariantAsset(); // variante → injeta o ups-multi.js
      if (document.body) showPreviewBanner(preview);
      else document.addEventListener('DOMContentLoaded', function () { showPreviewBanner(preview); });
      return; // preview não bucketiza, não dispara GA4, não grava cart attr
    }

    // ⚠️ NÃO injetar/segurar NADA antes do kill switch. O AB#03 fica DESLIGADO por
    // padrão; se a variante (ups-multi.js — 3 produtos) for injetada no load antes de
    // confirmar `enabled`, quem cai no bucket "variant" vê o pop-up multi-produto MESMO
    // com o teste OFF, sobrepondo o ups-c.js (pop-up permanente de 1 produto). Foi o bug
    // reportado 08/Jul/2026: a LP mostrava 3 produtos com o teste desligado. Regra: com o
    // teste OFF a LP tem que ficar 100% intocada → toda injeção mora DENTRO do fetchEnabled.
    var syncBucket = resolveBucket();

    // KILL SWITCH: só roda o fluxo normal (e injeta a variante) se o teste estiver enabled
    // no ab_config. Off (ou falha de leitura) → a LP fica intocada (control natural, só o
    // ups-c.js estático). O pop-up só aparece no clique, então o pequeno atraso da leitura
    // do kill switch é invisível (sem flicker).
    fetchEnabled(safe(function (enabled) {
      if (!enabled) {
        window.__gudayAb = { test: AB.testName, enabled: false };
        return;                                  // teste OFF → não injeta, não segura clique, não conta
      }
      var bucket = syncBucket;                   // já resolvido acima (mesmo cookie/LS)
      // CLICK-HOLD GUARD (corrige a corrida: comprar ANTES do pop-up armar). Na variante o
      // pop-up (ups-multi.js) carrega com defer; nessa janela o handler NATIVO da LP já
      // levava o clique em [data-offer-add] direto pro /checkout (a pessoa comprava SEM ver
      // o pop-up). Fix: se variant, injeta o asset e segura os cliques em capture até o
      // pop-up armar (window.__gdMultiConsumePending); timeout de segurança (SAFETY_MS) libera
      // pro fluxo nativo se nunca carregar → jamais trava a compra. Control fica intocado.
      // AGORA roda SÓ com o teste enabled (era antes do kill switch — causava o bug do multi
      // vazar com o teste OFF).
      if (bucket === AB.variants[1]) {
        injectVariantAsset();
        installClickHold();
      }
      wireActivation(bucket);                    // só conta quando clicar num bundle
      // expõe pra debug/console
      window.__gudayAb = { test: AB.testName, enabled: true, bucket: bucket, activated: function () { return activated; } };
    }));
  });

  /* ====== click-hold: segura o clique em [data-offer-add] até o pop-up armar ======
     Só instalado na variante. Guarda o ÚLTIMO clique pendente; o ups-c.js consome via
     window.__gdMultiConsumePending(). Fallback por timeout libera pro fluxo nativo. */
  var HOLD_SAFETY_MS = 3500;
  var holdInstalled = false, holdReleased = false, holdTimer = null;
  function installClickHold() {
    if (holdInstalled) return; holdInstalled = true;
    // sinaliza pro handler nativo (lp-5-razoes-bundles.js) e pro ups-c.js que estamos segurando
    window.__gdMultiHold = true;
    document.addEventListener('click', onHeldClick, true);   // capture: antes do nativo
    holdTimer = setTimeout(releaseClickHold, HOLD_SAFETY_MS); // safety: nunca trava a compra
  }
  function onHeldClick(e) {
    if (holdReleased) return;
    var btn = e.target && e.target.closest ? e.target.closest(AB.activationSelector) : null;
    if (!btn) return;
    // se o pop-up já está pronto, deixa o próprio ups-c.js tratar (não seguramos mais)
    if (typeof window.__gdMultiConsumePending === 'function' && window.__gdMultiReady) return;
    e.preventDefault(); e.stopPropagation();
    // guarda o clique pendente (dados do bundle) pro pop-up consumir quando armar
    window.__gdMultiPending = {
      variantId: parseInt(btn.getAttribute('data-variant-id'), 10),
      qty: parseInt(btn.getAttribute('data-qty'), 10) || 1,
      creatinas: parseInt(btn.getAttribute('data-creatinas'), 10) || (parseInt(btn.getAttribute('data-qty'), 10) || 1)
    };
    // se o pop-up já carregou entre o installClickHold e agora, consome imediatamente
    if (typeof window.__gdMultiConsumePending === 'function') window.__gdMultiConsumePending();
  }
  // Libera o hold: para de segurar cliques. Se havia um pendente e o pop-up nunca
  // carregou, dispara o checkout nativo pra não perder a compra — RESPEITANDO o fluxo
  // nativo de CADA LP (PAGE.nativeFlow) e gravando o _lp_source CERTO (PAGE.lpSource).
  // ⚠️ Antes a URL era hardcoded pra 5-Razões (_lp_source=lp-5-razoes-bundles) → na garrafa
  // gravava a origem errada. Agora é por-página.
  function releaseClickHold() {
    if (holdReleased) return; holdReleased = true;
    window.__gdMultiHold = false;
    if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
    document.removeEventListener('click', onHeldClick, true);
    var p = window.__gdMultiPending;
    if (p && p.variantId && !window.__gdMultiReady) {
      window.__gdMultiPending = null;
      var cfg = PAGE || resolvePageCfg();
      var src = cfg.lpSource;
      if (cfg.nativeFlow === 'ajax-add') {
        // garrafa: replica o fluxo nativo (offer2.liquid:641-652) — /cart/add.js + delay + /checkout.
        // Mantém o delay (nativeAddDelayMs) por conservadorismo (espelha o timing nativo).
        safe(function () {
          fetch('/cart/add.js', {
            method: 'POST', keepalive: true,
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: p.variantId, quantity: p.qty, properties: { _lp_source: src } })
          }).then(function () {
            setTimeout(function () { window.location.href = '/checkout'; }, AB.nativeAddDelayMs);
          }).catch(function () {
            setTimeout(function () { window.location.href = '/checkout'; }, AB.nativeAddDelayMs);
          });
        })();
      } else {
        // 5-Razões (e default): checkout via permalink nativo (mesma URL do lp-5-razoes-bundles.js)
        window.location.href = '/cart/add?id=' + p.variantId + '&quantity=' + p.qty +
          '&properties[_lp_source]=' + encodeURIComponent(src) + '&return_to=/checkout';
      }
    }
  }
  // o ups-c.js chama isto quando terminar de armar, pra encerrar o hold sem fallback
  window.__gdMultiReleaseHold = function () {
    holdReleased = true; window.__gdMultiHold = false;
    if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
    document.removeEventListener('click', onHeldClick, true);
  };

  // bfcache: ao voltar pelo browser, re-arma o estado (bucket continua do cookie)
  window.addEventListener('pageshow', function (e) { if (e.persisted) { /* bucket persiste no cookie; nada a resetar */ } });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
